export enum SortOrder {
    ASC = 1,
    NO_SORT = 0,
    DESC = -1,
};